import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Shield, LayoutDashboard, ShieldAlert, ScrollText, Users, LogOut, Settings, Save, Activity, Server, Wifi, Mail, CreditCard, BrainCircuit    } from 'lucide-react';
import SubscriptionGuard from './SubscriptionGuard'; 
import logo from '../img/image-2026-05-21-08-52-40-636.png';

const SettingsPage = ({ onLogout }) => {
  const [slackUrl, setSlackUrl] = useState('');
  const [email, setEmail] = useState('');
  const [data, setData] = useState({subscription_status: 'loading', agents_online: 0, uptime: '...' });
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();
  const userRole = localStorage.getItem('role');
  const tenantId = localStorage.getItem('tenant_id');

  const fetchSettings = async () => {
    try {
      const token = localStorage.getItem('token');
      const config = { headers: { 'X-NOC-Token': token } };
      const [s, slack, mail] = await Promise.all([
        axios.get('https://ai-noc.skynix.co/api/stats', config),
        axios.get('https://ai-noc.skynix.co/api/settings/slack/', config),
        axios.get('https://ai-noc.skynix.co/api/settings/email/', config)
      ]);
      setData(s.data);
      setSlackUrl(slack.data.webhook_url || ''); 
      setEmail(mail.data.notification_email || ''); 
    } catch (e) { console.error("Fetch error:", e); }
  };

  useEffect(() => { fetchSettings(); }, []);

  const handleSave = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const config = { headers: { 'X-NOC-Token': token } };
      await Promise.all([
        axios.post('https://ai-noc.skynix.co/api/settings/slack/', { webhook_url: slackUrl }, config),
        axios.post('https://ai-noc.skynix.co/api/settings/email/', { notification_email: email }, config)
      ]);
      alert("Notification settings updated successfully!");
    } catch (e) { alert("Error saving settings"); }
    setLoading(false);
  };

  return (
    <div className="d-flex" style={{ minHeight: '100vh', backgroundColor: '#0b0e14', color: '#e2e8f0' }}>
       <SubscriptionGuard data={data} onLogout={onLogout} tenantId={tenantId}>
     
      <div className="sidebar" style={{ width: '64px', background: '#0d1117', borderRight: '1px solid #1e293b', height: '100vh', position: 'fixed', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '25px 0', zIndex: 1050 }}>
              <div
                        className="sidebar-item d-flex justify-content-center"
                        data-label="Go to Landing Page" 
                        onClick={() => window.location.href = 'https://noc.skynix.co'}
                        style={{
                          transform: 'translateY(-6px)',
                          marginBottom: '20px',
                          cursor: 'pointer' 
                        }}
                      >
                        <img
                          src={logo}
                          alt="SKYNIX"
                          style={{
                            width: '34px',
                            height: '34px',
                            objectFit: 'contain'
                          }}
                        />
                      </div>
        <div className="sidebar-item" data-label="Dashboard" onClick={() => navigate('/')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}><LayoutDashboard size={24} /></div>
        <div className="sidebar-item" data-label="Security Incidents"  onClick={() => navigate('/incidents')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}><ShieldAlert size={24} /></div>
        <div className="sidebar-item" data-label="System Logs" onClick={() => navigate('/logs')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}><ScrollText size={24} /></div>
        <div className="sidebar-item" data-label="Infrastructure" onClick={() => navigate('/infrastructure')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}><Server size={24} /></div>
        
        <div className="sidebar-item" data-label="User Management" onClick={() => navigate('/users')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}><Users size={24} /></div>
        
        <div className="sidebar-item" data-label="Billing & Plans" onClick={() => navigate('/subscription')} style={{ color: '#94a3b8', cursor: 'pointer', marginBottom: '30px' }}>
            <CreditCard size={24} />
        </div>
        <div className="sidebar-item active mt-auto mb-3" data-label="Settings"  onClick={() => navigate('/settings')} style={{ background: 'rgba(0, 242, 255, 0.1)', color: '#00f2ff', padding: '10px', borderRadius: '8px', cursor: 'pointer' }}>
          <Settings size={24} />
        </div>
        <div className="sidebar-item mb-3" data-label="Logout" onClick={onLogout} style={{ cursor: 'pointer' }}><LogOut size={24} className="text-danger" /></div>
      </div>


      <div className="main-wrapper" style={{ marginLeft: '64px', width: 'calc(100% - 64px)' }}>
                   
                   
                   <header className="soc-header" style={{ height: '60px', borderBottom: '1px solid #1e293b', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px', background: '#0b0e14' }}>
                     <div className="d-flex align-items-center gap-3">
                 
                      <h5 
                        className="sidebar-item tooltip-bottom m-0 d-flex align-items-center"
                        data-label="Go to Landing Page"
                        onClick={() => window.location.href = 'https://noc.skynix.co'}
                        style={{ 
                          color: '#00f2ff', 
                          fontSize: '1.1rem', 
                          cursor: 'pointer',
                          lineHeight: '1',      
                          transform: 'translateY(1px)' 
                        }}
                      >
                        SKYNIX <span className="text-white ms-2">AI-NOC</span>
                      </h5>
                       <div style={{ width: '1px', height: '24px', background: '#334155' }}></div>
                       <div className="text-secondary small d-flex align-items-center gap-2" style={{ fontSize: '0.9rem', fontWeight: '500', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                         <Activity size={16} className="text-info" /> Security Operations Center
                       </div>
                     </div>
                     
                     <div className="d-flex gap-4 align-items-center">
                      <div style={{ 
                                                     background: data.subscription_status === 'active' 
                                                       ? 'rgba(0, 242, 255, 0.1)' 
                                                       : data.subscription_status === 'loading' 
                                                         ? 'rgba(148, 163, 184, 0.1)' 
                                                         : 'rgba(239, 68, 68, 0.1)',  
                                                     
                                                     color: data.subscription_status === 'active' 
                                                       ? '#00f2ff' 
                                                       : data.subscription_status === 'loading' 
                                                         ? '#94a3b8' 
                                                         : '#ef4444', 
                                                     
                                                     padding: '4px 14px', 
                                                     borderRadius: '20px', 
                                                     fontSize: '0.8rem', 
                                                     border: `1px solid ${
                                                       data.subscription_status === 'active' 
                                                         ? '#00f2ff44' 
                                                         : data.subscription_status === 'loading' 
                                                           ? '#94a3b844' 
                                                           : '#ef444444'
                                                     }`, 
                                                     fontWeight: '600' 
                                                   }}>
                                                     {data.subscription_status === 'loading' 
                                                       ? 'Verifying license...' 
                                                       : data.subscription_status === 'active'
                                                         ? `Plan: ${data.plan_name} (${data.agents_online}/${data.max_servers})`
                                                         : 'SUBSCRIPTION INACTIVE'
                                                     }
                                                   </div>
                                                   <div className="header-metric small text-secondary">
                                                 <BrainCircuit size={14} className="me-1" style={{ color: '#a855f7' }}/> AI Tokens: <b className={data.ai_tokens_spent >= data.ai_tokens_limit ? "text-danger" : "text-white"}>
                                                     {data.ai_tokens_spent?.toLocaleString() || 0} / {data.ai_tokens_limit?.toLocaleString() || '1,000,000'}
                                                 </b>
                                               </div>
                       <div style={{ background: 'rgba(16,185,129,0.1)', color: '#10b981', padding: '4px 14px', borderRadius: '20px', fontSize: '0.8rem', border: '1px solid #10b98144', fontWeight: '600' }}>
                          Core: Healthy
                       </div>
                       <div className="header-metric small text-secondary">
                          <Server size={14} className="me-1" style={{ color: '#00f2ff' }}/> Agents Online: <b className="text-white">{data.agents_online}</b>
                       </div>
                       <div className="header-metric small text-secondary">
                          <Wifi size={14} className="me-1" style={{ color: '#00f2ff' }}/> Uptime: <b className="text-white" style={{ color: '#00f2ff' }}>{data.uptime}</b>
                       </div>
                     </div>
                   </header>

                
        {data.ai_tokens_spent >= data.ai_tokens_limit && (
          <div className="alert bg-danger bg-opacity-10 border-danger text-danger d-flex align-items-center gap-3 m-4 py-3 shadow-lg" 
              style={{ borderRadius: '12px', border: '1px solid #ef4444', animation: 'fadeIn 0.5s ease-in-out' }}>
            <ShieldAlert size={24} className="text-danger" />
            <div className="flex-grow-1">
              <div className="fw-bold" style={{ fontSize: '1rem' }}>ATTENTION! AI TOKENS EXPIRED</div>
              <div className="small opacity-80">
                Your current plan's AI analysis tokens have been fully consumed. 
                Automated threat detection is now paused. Please 
                <b className="text-decoration-underline ms-1 pointer" style={{cursor: 'pointer'}} onClick={() => navigate('/subscription')}>upgrade your plan</b> 
                to resume AI monitoring or analyze logs manually.
              </div>
            </div>
            <button className="btn btn-danger btn-sm fw-bold px-3" onClick={() => navigate('/subscription')}>
              UPGRADE NOW
            </button>
          </div>
        )}

        <main className="p-4">
          <div className="mb-4">
            <h2 className="fw-bold mb-1">Notification Settings</h2>
            <p className="text-secondary small">Define how your organization receives security alerts</p>
          </div>
          <div className="row g-4">
            <div className="col-md-6">
              <div className="noc-card h-100" style={{ background: '#151921', borderRadius: '12px', border: '1px solid #1e293b' }}>
                <div className="p-4 border-bottom border-secondary border-opacity-25">
                  <h6 className="m-0 fw-bold text-info d-flex align-items-center gap-2"><Activity size={18}/> Slack Webhook</h6>
                </div>
                <div className="p-4">
                  <label className="text-secondary small uppercase fw-bold mb-2">Webhook URL</label>
                  <input type="text" className="form-control bg-dark text-info border-secondary shadow-none mb-2" value={slackUrl} onChange={(e)=>setSlackUrl(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="noc-card h-100" style={{ background: '#151921', borderRadius: '12px', border: '1px solid #1e293b' }}>
                <div className="p-4 border-bottom border-secondary border-opacity-25">
                  <h6 className="m-0 fw-bold text-warning d-flex align-items-center gap-2"><Mail size={18}/> Email Alerts</h6>
                </div>
                <div className="p-4">
                  <label className="text-secondary small uppercase fw-bold mb-2">Destination Email</label>
                  <input type="email" className="form-control bg-dark text-warning border-secondary shadow-none mb-2" value={email} onChange={(e)=>setEmail(e.target.value)} />
                </div>
              </div>
            </div>
            <div className="col-12 text-end mt-4">
              <button onClick={handleSave} disabled={loading} className="btn btn-info fw-bold px-5 py-2">
                <Save size={20} className="me-2"/> Save Settings
              </button>
            </div>
          </div>
        </main>
      </div>
      </SubscriptionGuard>
    </div>
  );
};

export default SettingsPage;